import { Component } from "../../framework/Component";

export class Health implements Component {
  key = "health";
  current: number;
  max: number;

  constructor(current: number, max?: number) {
    this.max = max ?? current;
    this.current = current;
  }

  damage(amount: number): void {
    this.current = Math.max(0, this.current - amount);
  }

  heal(amount: number): void {
    this.current = Math.min(this.max, this.current + amount);
  }

  get alive(): boolean {
    return this.current > 0;
  }

  get ratio(): number {
    return this.current / this.max;
  }
}
